/* eslint-disable @typescript-eslint/no-unused-vars */

const FeaturedEventCard = () => {
  return null; // Component removed as per requirement to remove Flagship Event
};

export default FeaturedEventCard;

